function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var LebanonFlag = props => /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
  width: "1em",
  height: "1em",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), {}, {
  children: [/*#__PURE__*/_jsx("mask", {
    id: "a",
    width: "24",
    height: "18",
    x: "0",
    y: "3",
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: 'luminance'
    },
    children: /*#__PURE__*/_jsx("path", {
      fill: "#fff",
      d: "M0 3h24v18H0z"
    })
  }), /*#__PURE__*/_jsxs("g", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    mask: "url(#a)",
    children: [/*#__PURE__*/_jsx("path", {
      fill: "#F50101",
      d: "M24 3H0v4.5h24V3Zm0 13.5H0V21h24v-4.5Z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#F7FCFF",
      d: "M0 7.5h24v9H0v-9Z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#52AB0B",
      d: "M16.136 12.385c.056.65-2.345-.27-2.345-.01s2.572.718 2.568 1.301c-.005.583-3.05-.166-2.367.096.683.262 2.15.89 1.983 1.281-.356.835-2.72-.58-2.916-.3-.318.45 1.744 1.499 1.726 1.599-.033.192-1.408-.302-1.726.097-.259-.073-.378-.42-.458-.467l-.507-6.542s.455 6.16-.127 6.337c-.582.177-2.198.716-2.245.447-.018-.1 1.946-1.022 1.629-1.471-.234-.332-2.604.844-2.755.163-.674-.486 2.181-.906 2.181-1.402 0-.497-2.612.587-2.3-.104.313-.691 2.404-.939 2.443-1.034.072-.176-2.324.272-2.324 0 0-.516 1.434-.618 2.324-1.082.053-.53-2.16.521-2.324.097-.165-.425 2.828-1.525 2.755-1.61-.116-.136-2.528.475-2.13.154.772-.622 2.279-1.468 2.625-1.694 0 0 .042-.085.087-.056.044-.03.094-.06.094-.06s0 .532-.008.116c-.007-.416 3.533 1.403 3.573 1.864.046.539-2.187-.406-2.135.124.454.281 1.746.826 2.28 1.065.242.109-1.784-.23-1.741-.064.109.424 2.082.476 2.14 1.155Z"
    })]
  })]
}));
//# sourceMappingURL=Lebanon.js.map